import { Modal, InputNumber, Button } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { deleteInternshipJob } from "../../../../actions/internshipJobPostingActions";
import StudentCard from "./studentCardv2";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import GalkButton from "../../../common/component/button";
import "./mutipleInterviewStudentCardDialog.css";

const MutipleInterviewStudentCardDialog = ({
	modalCloseHandler,
	student,
	interviewCountHandler,
}) => {
	const { t } = useTranslation();
	const [interviewCount, setInterviewCount] = useState(1);

	useEffect(() => {
		if (student.noOfInterviewRequested && student.noOfInterviewRequested > 1) {
			setInterviewCount(student.noOfInterviewRequested);
		}
	}, [student.noOfInterviewRequested]);

	const increaseInterviewCount = () => {
		const updatedCount = interviewCount + 1;
		if (interviewCount < 10) {
			setInterviewCount(updatedCount);
			interviewCountHandler(student.id, updatedCount);
		}
	};
	const decreaseInterviewCount = () => {
		const updatedCount = interviewCount - 1;
		if (interviewCount > 1) {
			setInterviewCount(updatedCount);
			interviewCountHandler(student.id, updatedCount);
		}
	};
	const onChangeNumber = (value) => {
		if (value > 0 || value < 11) {
			setInterviewCount(value);
		}
	};

	return (
		<Modal
			title={t("modalTitle_multipleInterview")}
			visible={true}
			onCancel={modalCloseHandler}
			width={600}
			footer={null}
		>
			<div className="multipleInterview_modal_body">
				<div className="numberIncreaseContainer">
					<InputNumber
						min={1}
						max={10}
						defaultValue={1}
						bordered={false}
						value={interviewCount}
						onChange={onChangeNumber}
						size="small"
						style={{ width: 30 }}
					/>
					<span style={{ marginLeft: -10, color: "#1570EF" }}>
						{t("times")}
					</span>
					<Button.Group>
						<Button
							size="small"
							onClick={decreaseInterviewCount}
							icon={<MinusOutlined />}
						/>
						<Button
							size="small"
							onClick={increaseInterviewCount}
							icon={<PlusOutlined />}
						/>
					</Button.Group>
				</div>

				<StudentCard student={student} />
				<div className="project-form-controls-cont">
					<GalkButton type="primary" width={180} onClick={modalCloseHandler}>
						{t("ok")}
					</GalkButton>
				</div>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	isActionProgress: state.galkLabJobs.actionInProgress,
});

export default connect(mapStateToProps, { deleteInternshipJob })(
	MutipleInterviewStudentCardDialog
);
